import { Injectable } from '@angular/core';
import {  SettingsModel } from './settings.model';
import { get } from 'lodash-es';


/**
 * Application settings service
 * see README for details
 */
@Injectable({
    providedIn: 'root',
})
export class SettingsService {
    readonly #settings: SettingsModel = {
        ...{},
        ...get(window, 'appSettings') as SettingsModel,
    };
    /**
     * Get settings app
     */
    public get settings(): SettingsModel {
        return this.#settings;
    }

    /**
     * Get phone code from settings
     */
    public get phoneCode(): number {
        return this.#settings.phoneCode;
    }

    /**
     * Get currency format from settings
     */
    public get currencyFormat(): string {
        return this.#settings.currencyFormat;
    }

    /**
     * Returns the url of the authorization module
     */
    public get baseUrl(): string {
        const baseDomain: string = this.settings.APP_SETTINGS_BASE_DOMAIN.substr(1);
        return (
            window.location.protocol +
            '//' +
            baseDomain +
            (window.location.port ? ':' + window.location.port : '')
        );
    }
}
